// extracted by mini-css-extract-plugin
module.exports = {"base":"_33Ketgmh3ZTLtW7hasY57V","cards":"_2D_LJKRfAVkrELbSl2Yln3"};